module.exports = __webpack_public_path__ + "img/14new.8075c4fd.png";